/**
 * A COPY do cartão de onboarding — os rótulos, os verbos e as dicas das cinco
 * etapas, num objeto só.
 *
 * ★ **Por que fora do `.vue`.** Duas razões, e as duas são do repo. A primeira
 * é o teto de 500 linhas: com a etapa do dia a dia (18/09/2026) o cartão foi a
 * 698 linhas, e o que sai primeiro é o que NÃO é comportamento. A segunda é o
 * precedente do próprio módulo — `components/ia-confirm-action/copy.js` fez o
 * mesmo movimento pela mesma razão, e ali a copy também é a "fonte única" de
 * uma frase que aparece em mais de um estado do cartão.
 *
 * ★ **O corpo escrito é do FRONT, e é isto aqui.** O servidor manda só o que o
 * front não tem como derivar (as perguntas, as prioridades, os conectores com
 * estado, as skills, o slug do atalho); rótulo de botão, texto de apoio e dica
 * moram deste lado. É a régua declarada no backend (`core/onboarding/
 * cartoes.py`) e no roteiro da boas-vindas: duas fontes do mesmo conteúdo
 * divergem na primeira revisão de copy.
 *
 * ⚠️ **O que NÃO entra aqui: o formato da fala das prioridades.** Ele não é
 * copy, é CONTRATO com o backend — mora em
 * `utils/prioridades-do-dia-a-dia.js`, espelho de
 * `core/onboarding/prioridades.py`. Escrito aqui, a próxima revisão de copy
 * mudaria o contrato sem ninguém notar, e a escolha da pessoa pararia de ser
 * reconhecida em silêncio.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */

import {
  FALA_DO_CONTINUAR,
  FALA_DO_PULAR,
} from '@modules/aawz-intelligence-v2/ui-registry/chave-do-onboarding'

export const TEXTOS = {
  conectado: 'Conectado',
  conectar: 'Conectar',
  continuar: 'Continuar',
  pular: 'Pular',
  enviarRespostas: 'Enviar respostas',
  rodar: 'Rodar ',
  respostaPlaceholder: 'Sua resposta',
  // Fica à direita do título na etapa 1: responder tudo não é requisito, e
  // dizê-lo ANTES do formulário evita a pessoa travar na primeira pergunta.
  auxiliarDasPerguntas:
    'Responda o que souber agora. O que ficar em branco continua em aberto.',
  // ⚠️ **A etapa 2 NÃO tem linha auxiliar, e a ausência é a decisão.** A
  // primeira versão tinha um "Dá para marcar mais de uma." ao lado do título —
  // que é a MESMA coisa que a descrição da etapa, vinda do servidor
  // (`roteiro.ETAPAS[].descricao`: *"Marque quantas quiser. A IA prioriza o que
  // você escolher aqui."*), desenhada pela casca duas linhas abaixo. Duas
  // frases dizendo o mesmo no mesmo cartão é ruído, e elas divergiriam na
  // primeira revisão de copy. A etapa 1 tem auxiliar porque lá ele diz algo que
  // a descrição NÃO diz (que responder tudo não é requisito).
  // Em três partes porque a BARRA é destacada na cor da marca: interpolar a
  // frase inteira num `<span>` só pintaria tudo, e quebrá-la no template com
  // uma função violaria a regra de "sem chamada de função no template".
  dicaDasSkillsAntes: 'Digite ',
  dicaDasSkillsComando: '/',
  dicaDasSkillsDepois: ' no chat para ver todas as skills.',
  // O que a pessoa "diz" ao clicar. Vira a bolha dela na conversa, então é
  // frase de gente — não um código de comando. ⚠️ E é CONTRATO com o servidor
  // desde 21/09/2026 (só a resposta do cartão avança a apresentação): o
  // literal mora em `chave-do-onboarding.js`, ao lado do prefixo das respostas.
  falaDoContinuar: FALA_DO_CONTINUAR,
  falaDoPular: FALA_DO_PULAR,
  // ★ [owner, 21/09/2026] O que a etapa RESPONDIDA mostra no lugar dos botões:
  // ela foi pulada ("Pular") ou concluída sem nada a exibir (o "Continuar"
  // das etapas 3 e 4, o "Rodar" da 5). A etapa 1 mostra as respostas e a 2 as
  // escolhas — estas duas só caem aqui quando puladas.
  etapaPulada: 'Etapa pulada.',
  etapaConcluida: 'Etapa concluída.',
  erroDeNavegacao:
    'Não foi possível abrir a tela de conexão. Tente pelo menu lateral.',
}
